<script src="../driver-tier-chart/driver-tier-chart.component.ts"></script>

<div class="card-with-shadow bg-white p-2 mb-1">
  <mat-form-field class="w-full">
    <mat-select
      placeholder="Select Driver"
      [formControl]="selectedDriverControl"
      (valueChange)="selectCompanyDriver($event)"
    >
      <mat-option>
        <ngx-mat-select-search
          placeholderLabel="Search"
          noEntriesFoundLabel="No driver found"
          [formControl]="companyDriverSearchText"
        ></ngx-mat-select-search>
      </mat-option>
      <mat-option *ngFor="let driver of filteredTierDrivers$$ | async; trackBy: 'userID' | trackByKey" [value]="driver">
        <span>{{ driver.name }}</span>
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<div
  class="card-with-shadow bg-white p-2 h-full"
  *ngIf="driverMetricDetail$ | async as driverMetricDetail; else notSelected"
>
  <div *ngIf="(loading$$.asObservable() | async) === false; else isLoading">
    <div class="grid gap-y-2 pb-2">
      <div class="text-lg font-bold">Metric Detail</div>
      <div class="flex border-b border-gray-400 justify-between">
        <div class="flex items-center justify-center">
          <mat-icon>local_shipping</mat-icon>
          <div class="ml-1">Driver Name</div>
        </div>
        <div>{{ driverMetricDetail.metricDetail.name }}</div>
      </div>
      <div class="flex border-b border-gray-400 justify-between">
        <div
          class="flex items-center justify-center"
          [ngStyle]="{ color: driverMetricDetail.metricDetail.tierType | tierV2Color }"
        >
          <mat-icon>toll</mat-icon>
          <div class="ml-1">Current points</div>
          <div class="ml-1">- {{ driverMetricDetail.metricDetail.tierName | titlecase }}</div>
        </div>
        <div>{{ driverMetricDetail.metricDetail.totalPoints }}</div>
      </div>
      <div
        class="flex border-b border-gray-400 justify-between"
        *ngIf="driverMetricDetail.metricDetail.tierName !== 'black'"
      >
        <div
          class="flex items-center justify-center"
          [ngStyle]="{ color: driverMetricDetail.metricDetail.nextTierType | tierV2Color }"
        >
          <mat-icon>skip_next</mat-icon>
          <div class="ml-1">Point to next tier</div>
          <div class="ml-1">- {{ driverMetricDetail.metricDetail.nextTierName | titlecase }}</div>
        </div>

        <div>{{ driverMetricDetail.metricDetail.pointsToNextTier }}</div>
      </div>
      <div
        class="flex border-b border-gray-400 justify-between"
        *ngIf="driverMetricDetail.metricDetail.tierName !== 'blue'"
      >
        <div
          class="flex items-center justify-center"
          [ngStyle]="{ color: driverMetricDetail.metricDetail.previousTierType | tierV2Color }"
        >
          <mat-icon>skip_previous</mat-icon>
          <div class="ml-1">Point to previous tier</div>
          <div class="ml-1">- {{ driverMetricDetail.metricDetail.previousTierName | titlecase }}</div>
        </div>
        <div>{{ driverMetricDetail.metricDetail.pointsToPreviousTier }}</div>
      </div>
    </div>
    <hr />
    <mat-tab-group class="h-35 md:h-75">
      <mat-tab label="Events">
        <div
          class="text-lg text-gray-700 my-1 mt-2"
          *ngIf="
            driverMetricDetail.metricDetail.userGroupedEvents &&
            driverMetricDetail.metricDetail.userGroupedEvents.length > 0
          "
        >
          Contributing events in the past 2 weeks
        </div>
        <div
          class="text-lg text-gray-700 my-1 mt-2"
          *ngIf="
            !driverMetricDetail.metricDetail.userGroupedEvents ||
            driverMetricDetail.metricDetail.userGroupedEvents.length == 0
          "
        >
          There has been no activity in the past 2 weeks.
        </div>
        <table
          mat-table
          [dataSource]="driverMetricDetail.metricDetail.userGroupedEvents"
          class="w-full"
          *ngIf="
            driverMetricDetail.metricDetail.userGroupedEvents &&
            driverMetricDetail.metricDetail.userGroupedEvents.length > 0
          "
        >
          <ng-container matColumnDef="name">
            <th class="text-left text-gray-700 text-sm border-b" *matHeaderCellDef>Event Name</th>
            <td *matCellDef="let element" class="text-left border-b border-gray-400">{{ element.name }}</td>
          </ng-container>

          <ng-container matColumnDef="sumPoints">
            <th class="text-right text-gray-700 text-sm border-b" *matHeaderCellDef>Contributed Points</th>
            <td
              *matCellDef="let element"
              class="text-right border-b border-gray-400 font-bold"
              [ngClass]="element.sumPoints < 0 ? 'text-red-300' : 'text-green-100'"
            >
              {{ element.sumPoints | number }}
            </td>
          </ng-container>

          <ng-container matColumnDef="eventCount">
            <th class="text-right text-gray-700 text-sm border-b" *matHeaderCellDef>Occurrence Count</th>
            <td *matCellDef="let element" class="text-right border-b border-gray-400">
              {{ element.eventCount | number }}
            </td>
          </ng-container>

          <ng-container matColumnDef="noData">
            <mat-footer-cell *matFooterCellDef class="">
              There has been no activity in the past 2 weeks.
            </mat-footer-cell>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
          <mat-footer-row
            class="border-b-0"
            *matFooterRowDef="['noData']"
            [hidden]="
              driverMetricDetail.metricDetail.userGroupedEvents &&
              driverMetricDetail.metricDetail.userGroupedEvents.length > 0
            "
          ></mat-footer-row>
        </table>
      </mat-tab>
      <mat-tab label="Black Tier" *ngIf="driverMetricDetail.metricDetail.waysToBlackTier?.title">
        <div class="pt-1">
          <div class="font-bold text-lg">{{ driverMetricDetail.metricDetail.waysToBlackTier.title }}</div>
          <div class="text-gray-700">{{ driverMetricDetail.metricDetail.waysToBlackTier.subtitle }}</div>

          <div class="grid" style="grid-template-columns: 100px 120px 1fr">
            <div class="flex flex-col justify-center font-bold">Turn Rate</div>
            <mat-slider
              min="{{ driverMetricDetail.metricDetail.waysToBlackTier.minTurnRate }}"
              max="{{ driverMetricDetail.metricDetail.waysToBlackTier.maxTurnRate }}"
              step="1"
              value="{{ turnRate }}"
              (valueChange)="setTurnRate($event)"
            >
              <input matSliderThumb />
            </mat-slider>
            <div class="flex flex-col justify-center pl-2 font-bold">{{ turnRate }} loads</div>
          </div>
          <div class="grid" style="grid-template-columns: 100px 120px 1fr">
            <div class="flex flex-col justify-center font-bold">Hitch Length</div>
            <mat-slider
              min="{{ driverMetricDetail.metricDetail.waysToBlackTier.minHitchLength }}"
              max="{{ driverMetricDetail.metricDetail.waysToBlackTier.maxHitchLength }}"
              step="1"
              value="{{ hitchLength }}"
              (valueChange)="setHitchLength($event)"
            >
              <input matSliderThumb />
            </mat-slider>
            <div class="flex flex-col justify-center pl-2 font-bold">{{ hitchLength }} days</div>
          </div>
          <div class="grid" style="grid-template-columns: 100px 1fr 1fr">
            <div class="flex flex-col justify-center font-bold">Run Nights</div>
            <div>
              <mat-button-toggle-group
                class="rounded-full"
                name="nightShift"
                aria-label="night shift"
                value="{{ nightShift }}"
                (valueChange)="setNightShift($event)"
              >
                <mat-button-toggle value="true">
                  <div class="w-8 flex flex-row justify-end items-center">
                    <mat-icon *ngIf="nightShift === 'true'">check</mat-icon>
                    <div class="pr-2">Yes</div>
                  </div>
                </mat-button-toggle>
                <mat-button-toggle value="false">
                  <div class="w-8 flex flex-row justify-end items-center">
                    <mat-icon *ngIf="nightShift === 'false'">check</mat-icon>
                    <div class="pr-2">No</div>
                  </div>
                </mat-button-toggle>
              </mat-button-toggle-group>
            </div>
          </div>
          <hr class="text-gray-700 my-2" />
          <div *ngIf="currentTierSimulationExplanation$$ | async as explanation">
            <div class="font-bold text-lg">{{ explanation.title }}</div>
            <div class="text-gray-700">{{ explanation.subtitle }}</div>
            <ul class="pt-1 ml-2">
              <li
                class="list-disc py-1"
                *ngFor="
                  let description of explanation.descriptions;
                  trackBy: explanation.descriptions | trackByKey2: null
                "
              >
                {{ description }}
              </li>
            </ul>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>

<ng-template #notSelected>
  <div class="card-with-shadow bg-white p-2 h-full">
    <div
      *ngIf="(loading$$.asObservable() | async) === false; else isLoading"
      class="flex justify-center text-lg font-semibold p-2"
    >
      Select a driver's bar on the graph to the right or select dropdown above to view their metric detail.
    </div>
  </div>
</ng-template>

<ng-template #isLoading>
  <div class="card-with-shadow bg-white p-2 h-full">
    <div class="text-lg font-semibold p-2 flex items-center justify-center">
      <span>Loading driver metric detail</span>
      <mat-spinner [diameter]="30" class="ml-1"></mat-spinner>
    </div>
  </div>
</ng-template>
